// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__98PHg","rootMobile":"styles_rootMobile__3LR5S"};